export const SUBSIDIARIES = [
  {
    slug: "construction",
    name: "220 Construction",
    tag: "Build with Discipline",
    status: "in-planning",
    short: "Planned general contracting arm — residential, commercial, and civil scopes.",
    long: "220 Construction is the planned general-contracting arm of 220 Inc. It is being designed to operate with military-grade discipline and modern systems engineering — self-perform crews paired with a vetted contractor network. The division is in formation and will become operational alongside Phase 1 development.",
    image: "https://images.unsplash.com/photo-1581094288338-2314dddb7ece?w=1600&q=80",
    services: ["Plumbing", "Electrical", "HVAC", "Roofing", "Masonry", "Landscaping", "Painting", "Carpentry", "Demolition", "Site Prep", "Utility Trenching", "Concrete", "Remodeling"],
    href: "/subsidiaries/construction",
  },
  {
    slug: "realty",
    name: "220 Realty",
    tag: "Real Estate, Reimagined",
    status: "in-planning",
    short: "Planned brokerage, leasing, and acquisition arm.",
    long: "220 Realty is the planned brokerage and acquisition arm of 220 Inc. It will pair data-driven sourcing with on-the-ground market intelligence across the Columbus / Phenix City corridor as the division is stood up.",
    image: "https://images.unsplash.com/photo-1502672260266-1c1ef2d93688?w=1600&q=80",
    services: ["Residential Sales", "Commercial Leasing", "Land Acquisition", "Investment Sales", "Buyer Representation", "1031 Exchanges"],
    href: "/subsidiaries/realty",
  },
  {
    slug: "support-services",
    name: "220 Support Services",
    tag: "Operations, Done Right",
    status: "in-planning",
    short: "Planned facility services arm — janitorial, maintenance, landscaping, and support at portfolio scale.",
    long: "A planned workforce-first services brand intended to keep every 220 asset — and partner facility — running cleanly, safely, and beautifully. Operations will scale alongside the master plan.",
    image: "https://images.unsplash.com/photo-1573164574572-cb89e39749b4?w=1600&q=80",
    services: ["Janitorial", "Maintenance", "Landscaping", "Facility Support", "Cleaning Services", "Emergency Repair"],
    href: "/subsidiaries/support-services",
  },
  {
    slug: "club-220",
    name: "220 Event Center",
    tag: "A Premier Destination Venue",
    status: "in-development",
    short: "Planned event and entertainment venue for weddings, corporate events, conferences, banquets, fundraisers, and community gatherings.",
    long: "220 Event Center is a planned community asset and destination venue — a luxury black-and-gold space being designed to host weddings, corporate events, conferences, banquets, fundraisers, concerts, networking nights, private celebrations, and veteran appreciation events. The venue is in development; bookings are not yet being accepted.",
    image: "https://images.unsplash.com/photo-1519671482749-fd09be7ccebf?w=1600&q=80",
    services: ["Weddings & Receptions", "Corporate Events", "Conferences", "Banquets", "Fundraisers & Galas", "Concerts & Performances", "Networking Events", "Private Celebrations", "Veteran Appreciation Events", "Community Gatherings"],
    href: "/club-220",
  },
  {
    slug: "vip-transportation",
    name: "220 VIP Transportation",
    tag: "Movement, Elevated",
    status: "future",
    short: "Planned transportation service — party bus, executive sedan, and airport service.",
    long: "A future-initiative transportation brand planned to move clients with discretion, style, and reliability across the tri-state corridor — airport pickups, executive sedans, and event shuttles. Launch will follow 220 Event Center opening.",
    image: "https://images.unsplash.com/photo-1583267746897-2cf66319ef97?w=1600&q=80",
    services: ["Party Bus", "Executive Sedan", "Airport Transfers", "Event Shuttles", "Corporate Accounts"],
    href: "/subsidiaries/vip-transportation",
  },
  {
    slug: "education-certification",
    name: "220 Education & Certification",
    tag: "Skills That Build Communities",
    status: "in-planning",
    short: "Planned trade school, apprenticeships, and certifications — veteran priority.",
    long: "A planned accredited workforce pipeline designed to take residents from training to certification to placement inside the 220 ecosystem — closing the loop between workforce demand and community opportunity. Curriculum and accreditation in development.",
    image: "https://images.unsplash.com/photo-1521737604893-d14cc237f11d?w=1600&q=80",
    services: ["Trade Programs", "Certifications", "Apprenticeships", "Workforce Development", "Online Learning", "Placement Support"],
    href: "/education",
  },
  {
    slug: "tech",
    name: "220 Tech Department",
    tag: "Infrastructure, Software, AI",
    status: "in-development",
    short: "Planned internal technology group — platforms, smart buildings, and AI tooling.",
    long: "The planned in-house technology group building the platforms behind every 220 brand: property management software, resident portals, AI concierge, smart-building integrations, and data infrastructure. This site itself is the first deliverable.",
    image: "https://images.unsplash.com/photo-1518770660439-4636190af475?w=1600&q=80",
    services: ["Platform Engineering", "Smart Building IoT", "AI Tooling", "Data & Analytics", "Cybersecurity", "Internal IT"],
    href: "/subsidiaries/tech",
  },
  {
    slug: "veteran-housing",
    name: "Veteran Housing Initiative",
    tag: "A Promise to Those Who Served",
    status: "in-development",
    short: "Flagship planned housing program — transitional, recovery, affordable, and workforce.",
    long: "Our most important mission — and a Planned Development. The Veteran Housing Initiative is being designed to provide dignified, service-rich housing for veterans (transitional, recovery, affordable, and workforce) integrated with behavioral health, daycare, fitness, and on-site essentials. Construction will phase in alongside the master plan.",
    image: "https://images.unsplash.com/photo-1609220136736-443140cffec6?w=1600&q=80",
    services: ["Transitional Housing", "Recovery Housing", "Affordable Housing", "Workforce Housing", "Behavioral Health", "Case Management"],
    href: "/veteran-housing",
  },
  {
    slug: "property-management",
    name: "Property Management Division",
    tag: "Stewardship of Every Asset",
    status: "in-planning",
    short: "Planned multi-family, mixed-use, and commercial management arm with resident-first service.",
    long: "The planned property-management arm of 220 Inc., to operate every 220-developed property with one principle: residents and tenants are partners, not line items. Tech-enabled service, financial transparency, and 24/7 response — to come online with the first delivered properties.",
    image: "https://images.unsplash.com/photo-1486325212027-8081e485255e?w=1600&q=80",
    services: ["Tenant Relations", "Rent Collection", "Maintenance Coordination", "Owner Reporting", "Compliance", "24/7 Response"],
    href: "/subsidiaries/property-management",
  },
  {
    slug: "land-development",
    name: "Land Development Division",
    tag: "Master-Planning the Future",
    status: "in-planning",
    short: "Planned land acquisition, rezoning, remediation, and infrastructure arm for Phase 1 and beyond.",
    long: "The planned engine behind the long-term master plan — land acquisition, environmental remediation, rezoning, infrastructure upgrades, and scalable phasing. No parcels have been acquired at this stage; site identification and pre-acquisition work is in progress.",
    image: "https://images.unsplash.com/photo-1500382017468-9049fed747ef?w=1600&q=80",
    services: ["Land Acquisition", "Rezoning", "Environmental Remediation", "Infrastructure Upgrades", "Master Planning", "Public-Private Partnerships"],
    href: "/subsidiaries/land-development",
  },
];

export const findSub = (slug) => SUBSIDIARIES.find((s) => s.slug === slug);
